import { h, Component } from 'preact'
// @ts-expect-error   // fix this by defining the mapping to 'downshift' in tsconfig
import Downshift from 'downshift/preact'

import HitContainerControl from './HitContainerControl'
import { SearchBox } from './SearchBox'
import { SearchBoxProvided } from 'react-instantsearch/connectors'
import { SearchQuery } from './Search'
import { AllSearchResults, EventHit, Hit, isCommunityResult, isMultiIndexResult, SearchResult, SearchResults } from './index'
import { ContentType } from '@insided/shared/utils/contentType'
import { ControllerStateAndHelpers } from 'downshift'
import globals from '../../../utils/globals'

interface AlgoliaHit {
  content_type: ContentType
}

export type AlgoliaHits = AlgoliaHit[]

export type AlgoliaCallback = (hit: AlgoliaHit | null) => void

interface Props {
  newStyle?: boolean
  refine: SearchBoxProvided['refine']
  hits: AlgoliaHits
  allSearchResults: SearchResults | AllSearchResults | null
  updateSearch?: (query: SearchQuery, cb: () => void) => void
  callback: AlgoliaCallback
  exclude: any
  placeholder: any
  searchById: any
  finalInput: any
  submitIconType: any
}

class AlgoliaSearchForControl extends Component<Props> {
  itemToString (i: SearchResult) {
    return i ? i.title : i
  }

  render () {
    const { refine, allSearchResults, updateSearch, callback, exclude, placeholder, searchById, finalInput, submitIconType } = this.props

    let communityHits: Array<Hit | EventHit> = []
    if (isMultiIndexResult(allSearchResults)) {
      communityHits = (allSearchResults?.[globals('communityId')]?.hits || []).filter(isCommunityResult)
    } else {
      communityHits = (allSearchResults?.hits || []).filter(isCommunityResult)
    }
    return (
      <Downshift
        itemToString={this.itemToString}
        onChange={(item: AlgoliaHit, root: {clearSelection: () => void}) => {
          if (item !== null) {
            callback(item)
            root.clearSelection()
          }
        }}
      >
        {({
          getInputProps,
          getItemProps,
          highlightedIndex,
          setHighlightedIndex,
          openMenu,
          inputValue,
          reset,
          isOpen
        }: ControllerStateAndHelpers<SearchResult>) => {
          return (
            <div className='algolia-search-container'>
              <SearchBox
                isControl
                newStyle
                placeholder={placeholder}
                reset={reset}
                refine={refine}
                updateSearch={updateSearch}
                setHighlightedIndex={setHighlightedIndex}
                inputValue={inputValue || ''}
                getInputProps={getInputProps}
                openMenu={openMenu}
                isOpen={isOpen}
                key='search'
                submitIconType={submitIconType}
              />
              {
                inputValue && isOpen
                  ? <HitContainerControl
                      key='hits-container'
                      inputValue={inputValue}
                      hits={communityHits}
                      highlightedIndex={highlightedIndex}
                      getItemProps={getItemProps}
                      searchById={searchById}
                      finalInput={finalInput}
                      exclude={exclude}
                    />
                  : null
              }
            </div>
          )
        }}
      </Downshift>
    )
  }
}

export default AlgoliaSearchForControl
